module.exports = __webpack_public_path__ + "static/media/fique-ligado-icon.e709cc08.svg";